import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { QuickSearchProjectV2 } from './QuickSearchProjectV2';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type QuickSearchProjectResultV2Fragment = { __typename?: 'ProjectResult', result: { __typename?: 'Project', id: string, name: string, insertedAt: string, private: boolean, archivedAt?: string | null, imageUrl?: string | null, memberCount?: number | null, totalCount?: number | null, storage: number, uniqueMemberCount?: number | null, notificationsEnabled?: boolean | null, workspace?: { __typename?: 'Workspace', name: string, id: string } | null, owner?: { __typename?: 'AuthenticatedUser', name?: string | null } | null }, matches?: { __typename?: 'ProjectResultMatchConnection', totalCount: number, nodes: Array<{ __typename?: 'NameMatch', name?: string | null, terms?: Array<string | null> | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type ProjectResultFieldMatchesV2Fragment = { __typename?: 'ProjectResult', matches?: { __typename?: 'ProjectResultMatchConnection', totalCount: number, nodes: Array<{ __typename?: 'NameMatch', name?: string | null, terms?: Array<string | null> | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export const ProjectResultFieldMatchesV2 = /*#__PURE__*/ gql`
    fragment ProjectResultFieldMatchesV2 on ProjectResult {
  matches(page: {first: 10}) {
    nodes {
      ... on NameMatch {
        name
        terms
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ` as unknown as DocumentNode<ProjectResultFieldMatchesV2Fragment, unknown>;
export const QuickSearchProjectResultV2 = /*#__PURE__*/ gql`
    fragment QuickSearchProjectResultV2 on ProjectResult {
  result {
    ...QuickSearchProjectV2
  }
  ...ProjectResultFieldMatchesV2
}
    ${QuickSearchProjectV2}
${ProjectResultFieldMatchesV2}` as unknown as DocumentNode<QuickSearchProjectResultV2Fragment, unknown>;

        

        
export const useQuickSearchProjectResultV2Fragment = (
  input: string | Omit<UseFragmentOptions<QuickSearchProjectResultV2Fragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'ProjectResult' } };
    return input;
  })();

  return useFragment<QuickSearchProjectResultV2Fragment>({
    fragment: QuickSearchProjectResultV2,
    fragmentName: 'QuickSearchProjectResultV2',
    ...options,
  });
};
  
        
        

        
export const useProjectResultFieldMatchesV2Fragment = (
  input: string | Omit<UseFragmentOptions<ProjectResultFieldMatchesV2Fragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'ProjectResult' } };
    return input;
  })();

  return useFragment<ProjectResultFieldMatchesV2Fragment>({
    fragment: ProjectResultFieldMatchesV2,
    fragmentName: 'ProjectResultFieldMatchesV2',
    ...options,
  });
};
  
        